import { IPromise } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { IConnectionData } from "@gtmhub/insights";
import { getModalTemplate } from "@gtmhub/shared/components/modal/template";
import {
  BrowseConnectionsActionsParams,
  BrowseInsightsActionParams,
  BrowseInsightsContext,
  BuildInsightActionParams,
  ExecuteInsightActionParams,
  ExecuteInsightContext,
  Insight,
  InsightSelectorData,
  UpdateInsightSelectorDataActionParams,
} from "@webapp/data-story/models/insights.models";
import { IDaxQueryResult } from "@webapp/integrations/models/powerbi-models";
import { IBuildInsightContext } from "./models";

export class InsightSelectorService {
  static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  public openBuildInsightModal(args: {
    insight: Insight;
    connectionData: IConnectionData;
    canGoBack: boolean;
    daxQueryResult?: IDaxQueryResult;
  }): IPromise<UpdateInsightSelectorDataActionParams | BrowseInsightsActionParams> {
    return this.$uibModal.open({
      template: getModalTemplate("insight-selector-build-insight"),
      windowClass: "insight-builder-modal",
      lazyLoadState: "gtmhub.insightboards",
      resolve: {
        buildInsightContext: (): IBuildInsightContext => ({
          confirmedInsight: args.insight,
          connectionData: args.connectionData,
          canGoBack: args.canGoBack,
          daxQueryResult: args.daxQueryResult,
        }),
      },
      controller: "BuildInsightCtrl",
    }).result;
  }

  public openExecuteInsightModal = (
    insight: Insight,
    data: InsightSelectorData
  ): IPromise<BrowseConnectionsActionsParams | BrowseInsightsActionParams | UpdateInsightSelectorDataActionParams> => {
    return this.$uibModal.open({
      template: getModalTemplate("insight-selector-execute-insight"),
      windowClass: "medium-small",
      resolve: {
        executeInsightContext: (): ExecuteInsightContext => ({
          insight,
          data: data,
        }),
      },
      controller: "ExecuteInsightCtrl",
      lazyLoadState: "gtmhub.insightboards",
    }).result;
  };

  public openBrowseConnectionsModal = (): IPromise<BrowseInsightsActionParams> => {
    return this.$uibModal.open({
      template: getModalTemplate("insight-selector-browse-connections"),
      windowClass: "medium-small",
      controller: "BrowseConnectionsCtrl",
      lazyLoadState: "gtmhub.insightboards",
    }).result;
  };

  public openBrowseInsightsModal = (
    connectionData: IConnectionData
  ): IPromise<BrowseConnectionsActionsParams | BuildInsightActionParams | ExecuteInsightActionParams> => {
    return this.$uibModal.open({
      template: getModalTemplate("insight-selector-browse-insights"),
      windowClass: "medium-small",
      resolve: {
        browseInsightsContext: (): BrowseInsightsContext => ({
          connectionData,
        }),
      },
      controller: "BrowseInsightsCtrl",
      lazyLoadState: "gtmhub.insightboards",
    }).result;
  };
}
